__turbopack_context__.v({
  "logo": "EMergeAllianceNotice-module-scss-module__GPCNma__logo",
  "tab": "EMergeAllianceNotice-module-scss-module__GPCNma__tab",
});
